import { createFileRoute } from "@tanstack/react-router";

import Login from "areas/auth/pages/Login";


export const Route = createFileRoute("/_public/auth/")({
	component: () => <Login />,
	staticData: {
		lite: true
	}
});